import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { ConsultaComponent } from './components/consulta/consulta.component';
import { CallbackComponent } from './components/callback/callback.component';
import { ErrorComponent } from './components/error/error.component';

export const ROUTES: Routes = [
    {path: 'notfound', component: NotFoundComponent},
    {path: 'consulta', component: ConsultaComponent},
    {path: 'callback', component: CallbackComponent},
    {path: 'callback/:recaudadora/:tipo/:cuenta/:aut', component: CallbackComponent},
    {path: 'callback/:recaudadora/:tipo/:cuenta/:aut/:tipoPeticion', component: CallbackComponent},
    {path: 'callback/:recaudadora/:tipo/:cuenta/:aut/:tipoPeticion/:transactionId', component: CallbackComponent},
    {path: 'error', component: ErrorComponent},
    {path: 'error/:recaudadora/:tipo/:cuenta/:lineaCaptura/:idPagoRegresoBancoLog', component: ErrorComponent},
    {path: 'error/:recaudadora/:tipo/:cuenta/:lineaCaptura/:idPagoRegresoBancoLog/:tipoPeticion', component: ErrorComponent},
    {path: 'error/:recaudadora/:tipo/:cuenta/:lineaCaptura/:idPagoRegresoBancoLog/:tipoPeticion/:transactionId', component: ErrorComponent},

    {path: '', pathMatch: 'full', redirectTo: 'consulta'},
    {path: '**', pathMatch: 'full', redirectTo: 'notfound'}
];
